import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';

const KEY = 'cookie-consent';

const read = () => {
  try {
    return localStorage.getItem(KEY);
  } catch (e) {
    return 'denied'; // private mode / storage blocked: treat as declined, don't nag
  }
};

export const CookieConsent = () => {
  const [choice, setChoice] = useState(read);

  if (choice) return null;

  const decide = (value) => {
    try {
      localStorage.setItem(KEY, value);
    } catch (e) {}
    if (value === 'accepted' && typeof window.gtag === 'function') {
      window.gtag('consent', 'update', { analytics_storage: 'granted' });
    }
    setChoice(value);
  };

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Kebijakan cookie"
      className="fixed bottom-0 inset-x-0 z-50 p-4 sm:p-6"
    >
      <div className="container mx-auto max-w-4xl bg-card border border-border shadow-2xl rounded-2xl p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <Cookie className="text-brand-700 flex-shrink-0" size={28} aria-hidden="true" />
        <p className="text-sm text-foreground/80 leading-relaxed flex-1">
          Kami memakai cookie analitik untuk memahami cara pengunjung memakai situs ini. Anda bisa menolak tanpa
          mengurangi fungsi situs. Selengkapnya di{' '}
          <Link to="/kebijakan-privasi" className="text-brand-700 underline font-medium hover:text-brand-800">
            Kebijakan Privasi
          </Link>
          .
        </p>
        <div className="flex gap-3 flex-shrink-0 w-full sm:w-auto">
          <button
            onClick={() => decide('denied')}
            className="flex-1 sm:flex-none px-5 py-2.5 rounded-lg border border-border text-foreground/70 hover:bg-muted font-medium transition-colors"
          >
            Tolak
          </button>
          <button
            onClick={() => decide('accepted')}
            className="flex-1 sm:flex-none px-5 py-2.5 rounded-lg bg-brand-700 hover:bg-brand-800 text-white font-semibold transition-colors"
          >
            Terima
          </button>
        </div>
      </div>
    </div>
  );
};
